import { Link, router } from "@inertiajs/react"
import { LogOut, Settings } from "lucide-react"

import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu"
import { UserInfo } from "@/components/user-info"
import { useMobileNavigation } from "@/hooks/use-mobile-navigation"
import { sessionPath, settingsProfilePath } from "@/routes"
import type { Auth } from "@/types"

interface UserMenuContentProps {
  auth: Auth
}

export function UserMenuContent({ auth }: UserMenuContentProps) {
  const { session, user } = auth
  const cleanup = useMobileNavigation()

  const handleLogout = () => {
    cleanup()
    router.flushAll()
  }

  return (
    <>
      <DropdownMenuGroup>
        <DropdownMenuLabel className="p-0 font-normal">
          <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
            <UserInfo user={user} showEmail={true} />
          </div>
        </DropdownMenuLabel>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuGroup>
        <DropdownMenuItem
          render={
            <Link
              className="block w-full"
              href={settingsProfilePath()}
              prefetch
              onClick={cleanup}
            />
          }
        >
          <Settings className="mr-2" />
          Settings
        </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        nativeButton
        render={
          <Link
            className="block w-full"
            method="delete"
            href={sessionPath({ id: session.id })}
            onClick={handleLogout}
          />
        }
      >
        <LogOut className="mr-2" />
        Log out
      </DropdownMenuItem>
    </>
  )
}
